<template>
  <div>
    <div
      v-if="isMyRequest && (request.status === 'ACTIVE' || request.status === 'EXPIRED' || request.status === 'DISCUSSING')"
      class="card"
    >
      <div class="card-body">
        <p>{{ $t('requestCloseFlow.sorunuzTamamlandqdanVYaEhtiyacOlmadZamanSorunuzuBa') }}</p>

        <button
          class="btn btn-block btn-outline-danger"
          @click="closeRequestSelectResult()"
        >
          {{ $t('requestCloseFlow.sorunuBala') }}
        </button>
        <button
          class="btn btn-block btn-outline-primary mt-2"
          @click="notifyUsers()"
        >
          {{ $t('requestCloseFlow.notifyUsers') }}
        </button>
      </div>
    </div>
    <div
      v-if="isMyRequest && request.status === 'CLOSED' && request.isSuccess === 1"
      class="card mt-3"
    >
      <div class="card-body">
        <p>{{ $t('requestCloseFlow.changeWinnersDescription') }}</p>
        <button
          class="btn btn-block btn-outline-primary"
          @click="changeWinnersModal()"
        >
          {{ $t('requestCloseFlow.changeWinners') }}
        </button>
        <div
          v-if="request.winnerChanged"
          class="alert alert-warning mt-3"
        >
          <span class="badge badge-warning mr-2">!</span>
          {{ $t('vendorManagementPurchasesReports.winnerChanged') }}
        </div>
      </div>

    </div>
    <b-modal
      id="modal-close-is-success"
      centered
      :title="$t('requestCloseFlow.sorununBalanmas')"
      :hide-footer="true"
      class="theme-modal"
    >
      <div>
        <p class="lead">
          {{ $t('requestCloseFlow.zhmtOlmasaSorunuzunNticsiIlBalMlumatVerin') }}
        </p>


        <div v-if="request.requestType==='PQT' && request.autoWinner===2">
          <div class="my-3 text-danger">
            {{ $t('requestCloseFlow.sorunuUurluBalamaqNTklifVernXslrlMzakirEdin') }}
          </div>
        </div>
        <button
          class="btn btn-lg btn-block btn-success my-3"
          @click="closeRequestSuccessful"
        >
          {{ $t('requestCloseFlow.sorumUurluOldu') }}
        </button>

        <button
          class="btn btn-lg btn-block btn-warning my-3"
          @click="closeRequestUnSuccessful"
        >
          {{ $t('requestCloseFlow.sorumUursuzOldu') }}
        </button>
      </div>
    </b-modal>
    <b-modal
      id="modal-close-winner-selection"
      centered
      :title="$t('requestCloseFlow.sorununBalanmas')"
      :hide-footer="true"
      class="theme-modal"
    >
      <div>
        <div v-if="uniqueCommentList.length<1">
          <div class="text-danger">
            {{ $t("requestCloseFlow.buSrgnUgurluBglmq") }}
          </div>
        </div>
        <div v-else>
          <label
            class="lead"
            for="closeRequestNote"
          >{{ $t('requestCloseFlow.qalibTklifiSein') }}</label>

          <div
            v-for="c in uniqueCommentList"
            :key="c.id"
            class="form-check mb-3"
          >
            <input
              :id="`rwc_${c.id}`"
              v-model="closeRequestWinners"
              class="form-check-input"
              type="checkbox"
              :value="c.id"
            >
            <label
              class="form-check-label"
              :for="`rwc_${c.id}`"
            >
              <strong>{{ c.user.name }} {{ c.user.surname }}</strong> <br>
              {{ c.company.name }} {{ getCompanyFormat(c.company.format) }}
            </label>
          </div>


          <button
            class="btn btn-block btn-warning"
            @click="closeRequest(1)"
          >
            {{ $t('requestCloseFlow.sorumUurluOldu') }}
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-close-winner-selection-pqt"
      centered
      :title="$t('requestCloseFlow.sorununBalanmas')"
      :hide-footer="true"
      class="theme-modal"
    >
      <div />
      <div>
        <div v-if="offers.length<1">
          <div class="text-danger">
            {{ $t("requestCloseFlow.buSrgnUgurluBglmq") }}
          </div>
        </div>
        <div v-else>
          <label
            class="lead"
            for="closeRequestNote"
          >{{ $t('requestCloseFlow.qalibTklifiSein') }}</label>

          <div
            v-for="c in offers"
            :key="c.id"
            class="form-check mb-3"
          >
            <input
              :id="`rwc_${c.id}`"
              v-model="closeRequestWinners"
              class="form-check-input"
              type="checkbox"
              :value="c.id"
            >
            <label
              class="form-check-label"
              :for="`rwc_${c.id}`"
            >

              {{ c.requestUser.company.name }} {{ getCompanyFormat(c.requestUser.company.format) }}
            </label>
          </div>

          <div>
            <label
              for="closeRequestNote"
              class="lead"
            >{{ $t("requestCloseFlow.qalibScmnzEsasLdnr") }}</label>
            <textarea
              id="closeRequestNote"
              v-model.trim="closeRequestNote"
              class="form-control"
              rows="3"
              required
            />
            <div
              v-if="closeRequestNote.length<20"
              class="text-secondary mt-1"
            >
              {{ $t("requestCloseFlow.sorguQyd20SmvolOlmalidi") }}
            </div>
            <div class="text-danger">
              {{ $t("requestCloseFlow.qeydEtdynzSbbDigerIstrakcGndrl") }}
            </div>
          </div>
          <button
            class="btn btn-block btn-warning"
            @click="closeRequest(1)"
          >
            {{ $t('requestCloseFlow.sorumUurluOldu') }}
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-close-un-success"
      centered
      :title="$t('requestCloseFlow.sorununBalanmas')"
      :hide-footer="true"
      class="theme-modal"
    >
      <form @submit.prevent="closeRequest(0)">
        <div>
          <label
            for="closeRequestNote"
            class="lead"
          >{{ $t('requestCloseFlow.sorunuzunUursuzOlmasnnSbbiniQeydEdin') }}</label>
          <textarea
            id="closeRequestNote"
            v-model.trim="closeRequestNote"
            class="form-control"
            rows="3"
            required
          />
          <div
            v-if="closeRequestNote.length<20"
            class="text-secondary mt-1"
          >
            {{ $t("requestCloseFlow.sorguQyd20SmvolOlmalidi") }}
          </div>
          <div class="text-danger">
            {{ $t("requestCloseFlow.qeydEtdynzSbbDigerIstrakcGndrl") }}
          </div>
        </div>

        <div class="my-2 text-info">
          {{ $t('requestCloseFlow.sizinQeydinizGlckdDahaUurluSorularnYaradlmasVCavab') }}
        </div>
        <button
          type="submit"
          class="btn btn-block btn-warning"
        >
          {{ $t('requestCloseFlow.sorumUursuzOldu') }}
        </button>
      </form>
    </b-modal>

    <b-modal
      id="modal-change-winners"
      centered
      :title="$t('requestCloseFlow.changeWinners')"
      :hide-footer="true"
      class="theme-modal"
    >
      <div>
        <div v-if="offers.length<1">
          <div class="text-danger">
            {{ $t("requestCloseFlow.buSrgnUgurluBglmq") }}
          </div>
        </div>
        <div v-else>
          <label
            class="lead"
            for="changeWinnersNote"
          >{{ $t('requestCloseFlow.qalibTklifiSein') }}</label>

          <div
            v-for="c in offers"
            :key="c.id"
            class="form-check mb-3"
          >
            <input
              :id="`cwc_${c.id}`"
              v-model="changeWinnersList"
              class="form-check-input"
              type="checkbox"
              :value="c.id"
            >
            <label
              class="form-check-label"
              :for="`cwc_${c.id}`"
            >
              {{ c.requestUser.company.name }} {{ getCompanyFormat(c.requestUser.company.format) }}
            </label>
          </div>

          <div>
            <div class="text-warning mb-2">
              Qalibin dəyişdirilmə səbəbi qeyd edilməlidir
            </div>
            <textarea
              id="changeWinnersReason"
              v-model.trim="changeWinnersReason"
              class="form-control"
              rows="3"
              required
            />
            <div
              v-if="changeWinnersReason.length<20"
              class="text-secondary mt-1"
            >
              {{ $t("requestCloseFlow.sorguQyd20SmvolOlmalidi") }}
            </div>
            <div class="text-danger">
              Bu mesaj yalnız qalib statusu dəyişdirilmiş şəxslərə gedəcəkdir
            </div>
          </div>

          <button
            class="btn btn-block btn-warning"
            @click="submitChangeWinners()"
          >
            {{ $t('requestCloseFlow.changeWinners') }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {closeRequest, notifyUsers, changeWinner} from "@/repositories/GeneralDataRepository";
import {getCompanyFormat} from "@/repositories/Utils";
import {mapState} from "vuex";

export default {
  name: 'RequestCloseFlow',
  props: {
    isMyRequest: {},
    request: {},
    offers: {},
    comments: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    winners: {
      type: Array,
      required: false,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      closeRequestWinners: [],
      closeRequestNote: '',
      changeWinnersList: [],
      changeWinnersReason: '',
    }
  },
  computed: {

    ...mapState({
      token: state => state.auth.token
    }),

    uniqueCommentList() {
      let list = [];
      let idS = [];

      this.comments.forEach(c => {
        if (idS.indexOf(c.user.id) === -1) {
          list.push(c);
          idS.push(c.user.id);
        }
      });

      return list;

    },
  },
  methods: {
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    changeWinnersModal() {
      // Initialize with current winners by matching company IDs
      this.changeWinnersList = this.offers
        .filter(offer => this.winners.some(winner => winner.company.id === offer.requestUser.company.id))
        .map(offer => offer.id);
      // Reset the reason text
      this.changeWinnersReason = '';
      this.$bvModal.show('modal-change-winners');
    },

    submitChangeWinners() {
      if (this.changeWinnersList.length < 1) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("requestCloseFlow.buSrgnUgurluBglmq"),
          icon: 'warning'
        });
      } else if (this.changeWinnersReason.length < 20) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("requestCloseFlow.sorguQyd20SmvolOlmalidi"),
          icon: 'warning'
        });
      } else {
        changeWinner(this.token, this.request.id, this.changeWinnersList, this.changeWinnersReason).then(data => {
          if (data.code === 200) {
            this.$bvModal.hide('modal-change-winners');
            this.$swal({
              title: this.$t('generalModal.successTitle'),
              text: this.$t('generalModal.operationSuccessful'),
              icon: 'success'
            });
            this.$emit('refresh');
          } else if (data.code === 403) {
            this.$swal({
              title: this.$t('generalModal.errorTitle'),
              text: this.$t('requestCloseFlow.noPermissionToChangeWinners'),
              icon: 'error'
            });
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            });
          }
        });
      }
    },

    closeRequestSelectResult() {
      this.$bvModal.show('modal-close-is-success');
    },

    closeRequestSuccessful() {
      if (this.request.requestType === 'RFQ' || (this.request.requestType === 'RFI' && this.request.requestSubType === 'purchase') || (this.request.requestType === 'PQT' && this.request.autoWinner === 1)) {
        if (this.request.requestType === 'PQT' && this.request.autoWinner === 1) {
          this.$bvModal.show('modal-close-winner-selection-pqt');
        } else {
          this.$bvModal.show('modal-close-winner-selection');
        }
      } else {
        this.closeRequest(1);
      }
    },
    closeRequestUnSuccessful() {
      this.$bvModal.show('modal-close-un-success');
    },

    notifyUsers() {
      this.$swal({
        title: this.$t('generalModal.infoTitle'),
        text: this.$t('requestCloseFlow.notifyUsers'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('generalModal.yes'),
        cancelButtonText: this.$t('generalModal.no')
      }).then((result) => {
        if (result.isConfirmed) {
          notifyUsers(this.token, this.request.id).then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t('generalModal.successTitle'),
                text: this.$t('generalModal.operationSuccessful'),
                icon: 'success'
              });
            } else if (data.code === 406) {
              this.$swal({
                title: this.$t('generalModal.errorTitle'),
                text: this.$t('requestCloseFlow.notifyUsersForbidden'),
                icon: 'error'
              });
            } else {
              this.$swal({
                title: this.$t('generalModal.errorTitle'),
                text: this.$t('generalModal.notSuccess'),
                icon: 'error'
              });
            }
          })
        }
      });
    },

    closeRequest(success) {

      if (
          (this.request.requestType === 'RFQ'
              || (this.request.requestType === 'RFI' && this.request.requestSubType === 'purchase') || (this.request.requestType === 'PQT' || this.request.autoWinner === 1))
          && this.closeRequestWinners.length < 1 && success === 1
      ) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("requestCloseFlow.buSrgnUgurluBglmq"),
          icon: 'warning'
        })
      } else {
        closeRequest(this.token, this.request.id, success, this.closeRequestNote, this.closeRequestWinners).then(data => {
          if (data.code === 200) {
            this.$bvModal.hide('modal-close-is-success');
            this.$bvModal.hide('modal-close-un-success');
            this.$bvModal.hide('modal-close-winner-selection');
            this.$bvModal.hide('modal-close-winner-selection-pqt');
            this.$emit('refresh');
          } else if (data.code === 403) {
            this.$swal({
              title: this.$t('generalModal.errorTitle'),
              text: this.$t('requestCloseFlow.noPermissionToCloseRequest'),
              icon: 'error'
            })
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
